var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.canViewCalendarEventPrivateInfo())?_c('v-btn',{staticClass:"my-4",attrs:{"block":"","large":"","elevation":"0","color":"primary secondary--text"},on:{"click":_vm.openDialog}},[_vm._v(" Preencher Formulário ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }